import styled from 'styled-components';
import { MobileModalContent, MobileModalLayout, MobileModalLeftTitle, ModalBackground, ModalFooter, ModalLeftTitle } from 'components/Modal/ModalForms';
import MobileBasicButton from 'components/Buttons/MobileBasicButton';
import { BackgroundColor, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { EventHandler, MouseEvent, ReactNode } from 'react';
import { Body1Bold, Body5Medium, Caption1Regular } from 'styles/Global/typography';
import { Radius } from 'styles/Global/objectStyles';
import { IDDiagnosis, IDDiagnosisNull } from 'models/DCK/basicInterface';
import { formattedTimeNotFilter } from 'utils/calculateTime';
import { calculateAge } from 'utils/calculateAge';
import GenderMan from 'assets/Icons/Gender/GenderMan';
import GenderWoman from 'assets/Icons/Gender/GenderWoman';
import { getRelationTypeStr } from 'utils/hospitalUtils';
import { ColumnDivider } from 'styles/Global/commonStyles';
import { changeMobileForm } from 'utils/changeMobileForm';

interface LeaveModalProps {
    clickFirstButton: () => void;
    clickSecondButton?: () => void;
    title: string;
    content: string;
    firstButton: string;
    secondButton: string;
    diagnosisInfo?: IDDiagnosisNull;
}
const ConfirmDialogueListLabelHorizonLeft = ({ clickFirstButton, clickSecondButton, title, content, firstButton, secondButton, diagnosisInfo }: LeaveModalProps) => {
    const { birthDate } = calculateAge(diagnosisInfo?.patientIdentityNumber || '');

    const handleBackgroundClick = (e: MouseEvent) => {
        // 클릭된 요소가 배경 자체인 경우에만 닫기
        if (e.target === e.currentTarget) {
            clickFirstButton();
        }
    };

    return (
        <ModalBackground $type='mobile' onClick={handleBackgroundClick}>
            <MobileModalLayout $gap='16px' $maxWidth='340px'>
                <ModalTitleAndContentContainer>
                    <ModalLeftTitle>{title}</ModalLeftTitle>
                    <MobileModalContent>{content}</MobileModalContent>
                </ModalTitleAndContentContainer>
                <Container>
                    <InfoWrapper>
                        <InfoLabel>상담일시</InfoLabel>
                        <InfoText>{formattedTimeNotFilter(diagnosisInfo?.diagnosisDateTime!)}</InfoText>
                    </InfoWrapper>
                    <InfoWrapper>
                        <InfoLabel>이름</InfoLabel>
                        <InfoText>
                            {diagnosisInfo?.patientName}
                            {diagnosisInfo?.patientGender === 'male' ? <GenderMan $width='16px' $height='16px' /> : <GenderWoman $width='16px' $height='16px' />}
                        </InfoText>
                    </InfoWrapper>
                    <InfoWrapper>
                        <InfoLabel>생년월일</InfoLabel>
                        <InfoText>{birthDate}</InfoText>
                    </InfoWrapper>
                    <InfoWrapper>
                        <InfoLabel>학령/학기</InfoLabel>
                        <InfoText>{diagnosisInfo?.gradeName}</InfoText>
                    </InfoWrapper>
                    <InfoWrapper>
                        <InfoLabel>주양육자</InfoLabel>
                        <InfoText style={{ gap: '8px' }}>
                            {getRelationTypeStr(diagnosisInfo?.relationType) || '-'} <ColumnDivider $height='12px' /> {diagnosisInfo?.parentName || '-'}
                        </InfoText>
                    </InfoWrapper>
                    <InfoWrapper>
                        <InfoLabel>연락처</InfoLabel>
                        <InfoText>{changeMobileForm(diagnosisInfo?.patientMobile!)}</InfoText>
                    </InfoWrapper>
                </Container>
                <ModalFooter $marginTop='4px'>
                    <MobileBasicButton $width='100%' $height='52px' onClick={clickFirstButton} $type='gray'>
                        {firstButton}
                    </MobileBasicButton>
                    <MobileBasicButton $width='100%' $height='52px' onClick={clickSecondButton} $type='fill'>
                        {secondButton}
                    </MobileBasicButton>
                </ModalFooter>
            </MobileModalLayout>
        </ModalBackground>
    );
};

export default ConfirmDialogueListLabelHorizonLeft;

const ModalTitleAndContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 10px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: ${Radius.radius_8};
    padding: 14px 16px;
    gap: 6px;
    background-color: ${BackgroundColor.color_background_primary_neutral};
`;

const InfoWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

const InfoLabel = styled(Caption1Regular)`
    width: 64px;
    color: ${TextColor.color_text_light};
`;

const InfoText = styled(Body5Medium)`
    display: flex;
    align-items: center;
    gap: 2px;
`;
